<ng-template #idleDialog>
    <sol-modal [type]="'info'" [title]="idleTitle" (dismissed)="onDismissed()">
        <sol-modal-body>
            <div>{{idleMessage}}</div>
        </sol-modal-body>
    </sol-modal>
</ng-template>